import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { updateStatus } from '../dashboard/dashboardActions';
import AiItineraryBuilder from './aiItineraryBuilder';

const mapStateToProps = (state) => ({
  ...state,
});

const mapDispatchToProps = (dispatch) => ({
  updateStatus: (params, headers) => dispatch(updateStatus(params, headers)),
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(AiItineraryBuilder)
);
